import { ReportBANEDProductListComponent } from './ned-product-list.component';
export default ReportBANEDProductListComponent;
